import { ReactNode } from 'react';

import styled from 'styled-components';

import { Stack, StackProps } from '@components/stack';
import { Text } from '@components/text';
import { Color, Font, theme } from '@styles/theme';

export type TitleDescriptionProps = {
  title: string;
  description?: string | ReactNode;
  icon?: ReactNode;
  details?: ReactNode;
  titleFont?: Font;
  titleColor?: Color;
  space?: StackProps['space'];
  iconRight?: ReactNode;
  disableEllipsis?: boolean;
};

export const TitleDescription = ({
  title,
  description,
  icon,
  details,
  titleFont,
  titleColor = 'textPrimary',
  space = 4,
  iconRight,
  disableEllipsis = false,
}: TitleDescriptionProps) => {
  return (
    <OverflowWrapper space={space} orientation="horizontal" align="center" justify="space-between">
      <OverflowWrapper space={space} orientation="horizontal" align="center">
        {icon}
        <DetailsContainer>
          <Line
            className="title"
            font={titleFont ?? 'semibold14'}
            text={title}
            ellipsisWithTooltip
            color={titleColor}
          />
          <Line
            className="description"
            font="regular14"
            color="textSecondary"
            text={description}
            ellipsisWithTooltip={!disableEllipsis}
          />
          {details}
        </DetailsContainer>
      </OverflowWrapper>
      {iconRight}
    </OverflowWrapper>
  );
};

const OverflowWrapper = styled(Stack)({
  overflow: 'hidden',
  '--icon-color': theme.color.elementPurple50,
});

const DetailsContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
});

const Line = styled(Text)({
  lineHeight: '1.25rem',
});
